import { Button, Stack, Typography } from '@mui/material';
import { reportLabels } from '../../constants/reportLabels';

interface ReportHistoryPagerProps {
  shown: number;
  total: number;
  hasMore: boolean;
  isLoading: boolean;
  isError: boolean;
  onLoadMore: () => void;
}

const ReportHistoryPager = ({ shown, total, hasMore, isLoading, isError, onLoadMore }: ReportHistoryPagerProps) => (
  <Stack direction="row" alignItems="center" justifyContent="space-between" gap={2} sx={{ mt: 2 }}>
    <Typography variant="body2" color={isError ? 'error' : 'text.secondary'} role="status">
      {isError ? reportLabels.history_load_more_error : reportLabels.history_count(shown, total)}
    </Typography>
    {hasMore && (
      <Button size="small" onClick={onLoadMore} loading={isLoading}>
        {isError ? reportLabels.retry_button : reportLabels.history_load_more}
      </Button>
    )}
  </Stack>
);

export default ReportHistoryPager;
